// extracted by mini-css-extract-plugin
export default {"header":"Fb2Ty","header__title":"YYI9p","appear-from-above":"UPgCc","appearFromAbove":"UPgCc"};